import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/optout',
      name: 'OptOutRecipient',
      component: () => import('@/views/pages/external/OptOutRecipient.vue'),
      props: route => ({
        mailingId: route.query.mailingId,
        recipientId: route.query.recipientId,
        jobId: route.query.jobId,
        email: route.query.email
      })
    },
    {
      path: '*',
      name: 'NotFound',
      component: () => import('@/views/pages/404.vue')
    }
  ]
})
export default router
